import { Outlet } from "react-router-dom";
import { useState } from "react";
import StudentSidebar from "./Studentsidebar";
import "./student.css";
const Studentlayout = () => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="lms">

      <StudentSidebar 
        collapsed={collapsed} 
        setCollapsed={setCollapsed} 
      />

      <div className={`main-wrap ${collapsed ? "collapsed" : ""}`}>

        

        <div className="content">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default Studentlayout;